import type { FC } from "react";
import iconEllipse from "../../assets/icons/icon-loading.png";
import './Loading.css'

interface LoadingProps {
    loading: boolean;
}

const Loading: FC<LoadingProps> = (props) => {
    const { loading } = props
    return (
        <>
            {loading &&
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#5A5A5A80",
                        zIndex: 1500
                    }}
                >
                    <img src={iconEllipse} className="rotate" alt="iconEllipse" width={40} height={40} />
                </div>}
        </>);
}

export default Loading
